import {BaseErrorReporterWrapper, Tags, ExtraData} from './BaseErrorReporterWrapper';
import {LogType} from '@gongxigames/framework/core/fragments/ConsoleLogger';

export class NullErrorReporter extends BaseErrorReporterWrapper {
    public init(): void {}
    public setTags(tags: Tags): void {}
    public addExtraData(tags: ExtraData): void {};
    public receiver(logType: LogType, logData: any[]): void {}
    public disable(): void {};
}